import React, { useMemo } from 'react';

interface IWidgetScopeContextValue {
  prefix: string;
  listIndex?: number | null;
}

/**
 * Context che permette di gestire il prefisso del name di un widget
 * all'interno di un form e in futuro altri parametri.
 * Per esempio viene popolato per gestire
 * i nomi dei widget interni a un widget repeatable (array).
 */
export const WidgetScopeContext = React.createContext<IWidgetScopeContextValue>(
  { prefix: '' },
);

export interface IWidgetScopeContextProviderProps {
  prefix: string;
  listIndex?: number | null;
  children: React.ReactNode;
}

export function WidgetScopeContextProvider(
  props: IWidgetScopeContextProviderProps,
) {
  const value = useMemo(
    () => ({ prefix: props.prefix, listIndex: props.listIndex }),
    [props.listIndex, props.prefix],
  );

  return (
    <WidgetScopeContext.Provider value={value}>
      {props.children}
    </WidgetScopeContext.Provider>
  );
}

export const useWidgetScopeContext = () => {
  return React.useContext(WidgetScopeContext);
};
